import { DynaFieldType } from '@/types';
import { z } from 'zod';

export const dynamicFormSchema = z.object({
  name: z.string().min(1, 'Le nom ne doit pas être vide').max(250, 'Le nom ne doit pas dépasser 250 caractères'),
  order: z
    .number({
      required_error: "L'ordre doit être un nombre",
    })
    .min(0, "L'ordre doit être un nombre positif"),
  typeDossierId: z.number({ required_error: 'Le type de dossier est requis' }).or(z.literal('')),
  formType: z.enum(['FORM', 'TABLE'], { required_error: 'Le type de formulaire est requis' }).or(z.literal('')),
  status: z.enum(['ACTIF', 'NON_ACTIF'], { required_error: 'Le statut est requis' }).or(z.literal('')),
});

export const dynamicFieldSchema = z.object({
  name: z.string().min(1, 'Le nom ne doit pas être vide').max(250, 'Le nom ne doit pas dépasser 250 caractères'),

  label: z.string().min(1, 'Le libellé ne doit pas être vide').max(250, 'Le libellé ne doit pas dépasser 250 caractères'),

  type: z
    .enum(Object.values(DynaFieldType) as [string, ...string[]], {
      required_error: 'Le type de champ est requis',
    })
    .or(z.literal('')),

  isRequired: z
    .boolean()
    .or(z.literal(''))
    .or(z.enum(['true', 'false'])),
  hasTotal: z
    .boolean()
    .or(z.literal(''))
    .or(z.enum(['true', 'false'])),
  isFormula: z
    .boolean()
    .or(z.literal(''))
    .or(z.enum(['true', 'false'])),
  formula: z.string().or(z.literal('')),

  order: z
    .number({
      required_error: "L'ordre doit être un nombre",
    })
    .min(0, "L'ordre doit être un nombre positif"),
});
